<script>
  import clsx from "clsx";
  export let displayPage;
  export let endPageNumber;
  export let startPageNumber;
  export let showPreviousItemsPage;
  export let showNextItemsPage;
  export let showPageDirect;
  export let showCounter = false;
  export let startItemNumber;
  export let endItemNumber;
  export let itemListLength;
  export let itemsPerPage;
  export let calcPageValues;
</script>

{#if showCounter && itemListLength > 1}
  <p class="my-2 text-center">
    Treffer <strong>{startItemNumber} – {endItemNumber}</strong> von <strong>{itemListLength}</strong>
    <select id="page_size2" size="1" bind:value={itemsPerPage} on:change={calcPageValues} class="p-1.5">
      <option value="10">10 pro Seite</option>
      <option value="20">20 pro Seite</option>
      <option value="30">30 pro Seite</option>
      <option value="50">50 pro Seite</option>
      <option value={itemListLength}>Alle anzeigen</option>
    </select>
  </p>
{/if}
{#if startPageNumber != endPageNumber}
  <nav class="my-2 flex flex-wrap items-center justify-center gap-1">
    <button class={clsx(displayPage < 2 && "invisible", "min-w-[2em] select-none p-1 text-center hocus:bg-theme-signal hocus:text-white")} type="button" on:click={showPreviousItemsPage}>❮</button>
    {#each Array(endPageNumber - startPageNumber + 1) as _, cnt}
      {#if displayPage == startPageNumber + cnt}
        <span class="block min-w-[2em] bg-theme-signal p-1 text-center text-white">{startPageNumber + cnt}</span>
      {:else}
        <button class="min-w-[2em] select-none p-1 text-center hocus:bg-theme-signal hocus:text-white" type="button" on:click={() => showPageDirect(startPageNumber + cnt)}>
          {startPageNumber + cnt}
        </button>
      {/if}
    {/each}
    <button class={clsx(displayPage >= endPageNumber && "invisible", "min-w-[2em] select-none p-1 text-center hocus:bg-theme-signal hocus:text-white")} type="button" on:click={showNextItemsPage}>
      ❯
    </button>
  </nav>
{/if}
